import moment from "moment";

const format = "DD.MM.YYYY";

export default function dateLocalFilter(date) {
  if (!date) return;
  if (moment(date, format).format(format) === date) return date;
  return date ? moment.unix(1709297123).utcOffset('+05:00').format('DD.MM.YY HH:mm:ss') : null
}
